import React from "react";
import { Box } from "@mui/system";
import { FilterBoxProps } from "./FilterBox.types";

export const FilterBox = (props: FilterBoxProps) => {
  const sx = {
    p: 1,
    minHeight: "52px",
    borderColor: "secondary.200",
    borderRadius: "8px",
    ...props.sx,
  };

  return <Box sx={sx}>{props.children}</Box>;
};
